import { redirectToUrl } from '../redirectToUrl/redirectToUrl';

// on web, we redirect to the URL returned by GeneralLogin.login_user response
export const redirectToLegacy = (redirectUrl: string): void => {
  redirectToUrl(redirectUrl);
};
